export interface PasswordRequirement {
  regex: RegExp;
  message: string;
}

export const passwordRequirements: PasswordRequirement[] = [
  { regex: /.{8,}/, message: 'Minimum 8 characters' },
  { regex: /[A-Z]/, message: 'Uppercase letter' },
  { regex: /[a-z]/, message: 'Lowercase letter' },
  { regex: /[\d]/, message: 'One number' },
  { regex: /[\W]/, message: 'One symbol' },
];

/** The same policy the PasswordStrength checklist renders, usable directly as a validator */
export function passwordMeetsAllRequirements(password: string): boolean {
  return passwordRequirements.every((requirement) => requirement.regex.test(password));
}
